var ISuggestionSearchDataType;
(function(ISuggestionSearchDataType) {
    ISuggestionSearchDataType.build = function(partial) {
        return partial;
    };
})(ISuggestionSearchDataType || (ISuggestionSearchDataType = {}));
export var ISuggestionEntry;
(function(ISuggestionEntry) {
    ISuggestionEntry.build = function(partial) {
        var _partial_label, _partial_url, _partial_sectionName, _partial_requestID;
        return {
            label: (_partial_label = partial === null || partial === void 0 ? void 0 : partial.label) !== null && _partial_label !== void 0 ? _partial_label : "",
            url: (_partial_url = partial === null || partial === void 0 ? void 0 : partial.url) !== null && _partial_url !== void 0 ? _partial_url : "",
            sectionName: (_partial_sectionName = partial === null || partial === void 0 ? void 0 : partial.sectionName) !== null && _partial_sectionName !== void 0 ? _partial_sectionName : "",
            searchData: ISuggestionSearchDataType.build(partial === null || partial === void 0 ? void 0 : partial.searchData),
            requestID: (_partial_requestID = partial === null || partial === void 0 ? void 0 : partial.requestID) !== null && _partial_requestID !== void 0 ? _partial_requestID : ""
        };
    };
})(ISuggestionEntry || (ISuggestionEntry = {}));
